import Vue from "vue";
import { tags , tagsArr } from "@/plugins/wApi/colors";
import { v4 } from "uuid";
import GO from "gojs";

// import store from "@/store/index";
// import router from '@/router/index' ; 
// import { sync } from 'vuex-router-sync'
// console.log( 'Vue.prototype : ' , Vue.prototype ) ; 

const { $wApi } = Vue.prototype ; 

const state = {
  $wApi , 
  DIAGRAM : {}, // Editor diagram handler 저장을 위한 변수

  crntPos : { x : 0 , y : 0 } , 

  emptyProcess : null , 
  processEditorElemID : '#editor-process' , 

  pending : {       // 대기 모음
    init:   false,    // 공정도 상세내용 불러오는 로딩
    detail: true,     // 공정도 디테일 불러오는 경우
    tags:   false,    // 태그를 불러오는 로딩
    update: false,    // 공정도 업데이트
  } , 

  elements : [] , 
  items : [] , 
  crntItem : null , 
  crntDiagram : null , 

  localStorageKey : '' , 
  user : null , 
  query : null , 
  editorType : null , 
  processId : null , 
  process : {} , 
  processInfo : {

    // links : [] , 
    // nodes : [] , 
  } , 

  status : {
    LNBOpenBln : false , // 아코디언 열림 닫힘 유무 
    DocumentOption : false ,
    readOnlyDocumentOption : false ,
    approvalRequestPopupViewBln : false , 
    templatePopupViewBln : false , 
    issueListViewBln : true , 
    unitProtocol: false , 
    nodeinfoViewBln : true , 
    logHistoryBln : false , 
    protocolTabMoveBln : true , 
    protocolTabType: 'tree',
    wikiPreviewerStatus: false,
    issueListStatus : {  },
    processViewerHandler: { },
  } , 

  popTagWrite : { // 팝업 태그 작성 관련 정보
    crntElement : null , 
    pos : { x : 0 , y : 0 , } , 
    status : {
      openBln : false , 
    } , 
  } , 

  LNBTagBalloon : { // 아코디언 재료 제목 말풍선
    viewBln : false , 
    elem : null , 
    name : '' , 
  } , 

  LNBTagContextMenu : { // 아코디언 재료 컨텍스트메뉴 말풍선
    viewBln : false , 
    elem : null , 
    tag : null , 
  } , 

  dragTag : { // 드래그 태그 
    tagElemClone : null , 
    dragBln : false , 
    dropBln : false , 
    pos : { x : 0 , y : 0 } , 
    data : {
      // label , 
      // tagId , 
      // category , 
      // tagShape , 
      // hasProtocol , 
    } , 
  } , 
  tagDropAbleBln : false , // 드래그 태그 드랍 가능 유무 

  templateData : [] , // 선택한 템플릿 데이터 
  templateInitBln : false , 

  protocolId : null , 
  keyOfProtocol : null , 
  slctProtocolKey : null , 
  protocolIssueList : [] , 

  crntProtocolInfo : {} , 

  pdfWiki : {
    writer : {} , 
  } , 
  
  protocolCreateFlag : false,
  innerProtocolId : null,
  processReadOnly : true,
} ; // end of state 

const mutations = {
  initDiagram (state : any , diagram ) {
    state.DIAGRAM = diagram
  },
  setInitInfo ( state : any , { user , query }) { // 기본 세팅 
    // console.log({ user })
    let { editorType , processId : processIdStr , protocolId, keyOfProtocol } = query ; 
    let processId : number = processIdStr ; 
    // console.log( 'protocolId : ' , protocolId ) ; 
    Object.assign( state , { ...state , 
      user , 
      query , 
      editorType , processId , protocolId , keyOfProtocol , 
    }) ; 
  } , 
  initItems ( state : any ) { // 로컬스토리지의 공정도 세팅
    // console.log( '--> initItems in' ) ; 
    let { items , localStorageKey } = state ; 
    items = JSON.parse( String( localStorage.getItem( localStorageKey ) )) || [] ; 

    items.map(( item : any ) => {
      // console.log( item.processId , 'item : ' , item ) ; 
      // console.log( item.processId , 'item.temporaryDeleteArr : ' , item.temporaryDeleteArr ) ; 
      if ( !item.hasOwnProperty( 'temporaryDeleteArr' ) ) {
        item.temporaryDeleteArr = {} ; 
      } 
    }) ; 

    /* console.log(
      'commnew.ts -> initItems in \n' , 
      'items : ' , items , '\n' , 
    ) ;  */
    Object.assign( state , { ...state , items }) ; 
  } , 
  updateElements ( state : any ) {
    console.log( 'updateElements in' ) ; 
  } , 
  updateStatus ( state : any , obj : any ) {
    /* let { status } = state ; 
    status[ key ] = bln ; 
    Object.assign( state.status , {
      ...state.status , 
      ... status , 
    }) ;  */

    // console.log({ obj }) ; 
    state.status = { ...state.status , ...obj } ; 
    // console.log( state.status ) ; 

    /* status : {
      LNBOpenBln : false , // 아코디언 열림 닫힘 유무 
      DocumentOption : false,
      approvalRequestPopupViewBln : false , 
      templatePopupViewBln : false , 
    } , 
    */
  } , 
  updateProcessInfo( state : any , obj ) {
    Object.assign( state.processInfo , {
      ...state.processInfo , 
      ... obj , 
    }) ; 
  } , 
  LNBopenToggleHandler ( state : any ) { // 아코디언 열고 닫기 유무 
    let { status , status : { LNBOpenBln }} = state ; 
    Object.assign( state.status , { ...status , LNBOpenBln : !LNBOpenBln }) ; 
  } , 
  closeTagWriteComp ( state : any ) {
    // console.log( '[commnew.ts -> closeTagWriteComp in]') ; 
    Object.assign( state.popTagWrite.status , {
      ...state.popTagWrite.status , 
      openBln : false , 
    }) ; 
  } , 
  dragTagUpdate ( state : any , newDragTag : any ) { // 드래그 태그 업데이트 
    Object.assign( state.dragTag , newDragTag ) ; 
  } , 
  chkTagDrop ( state : any , { bln }) {
    state.tagDropAbleBln = bln ; 
  } , 

  updateProtocols ( state : any , protocols : any ) {
    // console.log( 'updateProtocols in - protocols : ' , protocols ) ; 
    Vue.delete( state.processInfo , 'protocols' ) ; 
    Vue.set( state.processInfo , 'protocols' , protocols ) ; 
  } , 
  
  setPROCESS_INFO ( state : any, obj : any ) {
    for ( const [ k , v ] of Object.entries( obj )) {
      // console.log( 'k : ' , k , 'v : ' , v ) ; 
      Vue.set( state.processInfo , k , v ) ; 
    }
  } ,
  setEmptyProcess ( state : any , { bln }) {
    console.log({ bln }) ; 
    state.emptyProcess = bln ; 
  } , 
  initHandler ( state : any ) {
    // console.log('[ commnew.ts -> initHandler in]\n') ; 
    state.emptyProcess = null ; 
    state.crntItem = null ; 
    state.items = [] ; 
    state.elements = [] ; 
  } , 
  setCrntDiagram ( state : any , diagram : any ) {
    // console.log({ diagram }) ; 
    state.crntDiagram = diagram ; 
  } , 
  setCrntPos ( state : any , { x , y }) {
    state.crntPos = { x, y } ; 
  } , 
  setProcessId ( state : any , id : any ) {
    Vue.set( state , 'processId' , id ) ; 
  } , 
  setProtocolId ( state : any , id : any ) {
    // console.log('///' , { id }) ; 
    // state.protocolId  = id ; 
    Vue.set( state , 'protocolId' , id ) ; 
  } , 
  updateState ( state : any , obj : any ) {
    // console.log( obj ) ; 
    Object.assign( state , {
      ...state , 
      ...obj , 
    }) ; 
  } , 
  findFromNode (state : any , { targetNode, diagram, result }) {
    const nodeMapforKey = new Map()
    if(typeof targetNode === 'string') {
      targetNode = diagram.findNodeForKey(targetNode)
    }
    function find (node) {
      const nodeKey =  node.data.key
      let from:any = [], to:any = [], links:any = {}
      let findNode:any = {}
      node.linksConnected.each( link => {
        if( link.data.to ===  nodeKey ) {
          findNode = diagram.findNodeForKey(link.data.from)
          from.push(find(findNode))
        }
        else if ( link.data.from ===  nodeKey ) {
          findNode = diagram.findNodeForKey(link.data.to)
          to.push({key: link.data.to, data: findNode.data})
        }
      } )
      links.to = to;
      console.log(nodeKey, from, to)
      nodeMapforKey.set(node.key, {
        from, to, data: node.data
      })
      return {
        key: nodeKey,
        data : node.data,
        from, to
      }
    }
    const nodeTree = find(targetNode)

    if(typeof result === 'function') {
      result({
        nodeMapforKey, nodeTree
      })
    }
    return {
      nodeMapforKey, nodeTree
    }
  },

  setCrntProtocolInfo ( state : any , { parentKey , crnt = null }) {
    let { nodes } = state.processInfo ; 
    /* console.log(
      'crntProtocolInfo in ' , '\n' , 
      'parentKey :  ' , parentKey , '\n' , 
      'crnt :  ' , crnt , '\n' , 
      'state.processInfo : ' , state.processInfo , '\n' , 
    ) ;  */

    let parentObj = {
      parent : null , 
      crnt : null , 
    } ; 

    nodes.map(( info : any ) => {
      if ( info.key == parentKey ) {
        parentObj.parent = info 
      }
    }) ; 

    if ( crnt != null ) {
      parentObj.crnt = crnt ; 
    }

    // console.log({ parentObj }) ; 
    // state.crntProtocolInfo.crnt = crnt == null ? null : crnt ; 
    Vue.set( state , 'crntProtocolInfo' , parentObj ) ; 
  } , 

  updatePdfWiki ( state : any , obj : any) {
    // console.log({ obj })
    state.pdfWiki = { ...state.pdfWiki , ...obj } ; 
  } , 
  
  setProtocolCreateFlag ( state : any , flag : any) {
    state.protocolCreateFlag = flag;
  } ,

  setInnerProtocolId ( state : any ,{ innerProtocolId = null }) {
    state.innerProtocolId = innerProtocolId
  } ,

  setProcessReadOnly ( state : any , flag : any) {
    state.processReadOnly = flag;
  } ,
  
} ; // end of mutations 

const actions = {
  /* async setInitInfo2 ({ state , rootState }) {
    const unsync = sync( store , router ) ; 
    console.log({ store })
    console.log({ rootState }) ; 
    console.log( rootState.route ) ; 
    console.log( rootState.route.query ) ; 
  } ,  */
  async getProtocols ({ state } , _processId : any ) {
    let { processId , $wApi } = state ;
    if ( processId == null ) processId = _processId ; 
    let rslt = await $wApi.protocol.getProtocols({ 
      processId , 
      isMemo : true , 
      isConent : true , 
      isComment  : true , 
    });
    // console.log( '--------------- commnew.ts -> getProtocols in' , { 
    //   rslt , 
    // }) ; 

    rslt.map(( info : any ) => {
      // console.log( 'info.json : ' , info.json ) ; 
      info.json = JSON.parse( info.json ) ; 
      // console.log( '--> info.json : ' , info.json ) ; 
      // console.log({ info })
      if ( info.nodeMemo ) info.nodeMemo = JSON.parse( info.nodeMemo ) ; 
      if ( info.nodeContent ) info.nodeContent = JSON.parse( info.nodeContent ) ; 
      // if ( info.nodeComment ) info.nodeComment = JSON.parse( info.nodeComment ) ; 
    }) ; 
     return rslt ; 
  } , 
  async initElements ({ state , rootState , commit , dispatch }) {
    // console.log( '----- [ initElements in ]\n' ) ; 

    if ( state.elements.length != 0 ) { 
      // console.log( 'accordions elements init' ) ; 
      state.elements = [] ; // 아코디언 초기화 
    }
    
    let taglist = await dispatch( 'getElements' ) ; 
    taglist = await dispatch( 'getTags' , taglist ) ; 

    // console.log({ taglist }) ; 
    const { process , protocols } = await dispatch( 'getDetail' , taglist ) ; 

    /* console.log({
      process , 
      protocols , 
      json : JSON.parse( process.json ) , 
    }) ;  */
   
    if ( process && protocols ) {
      commit( 'initItems' ) ; 
      dispatch( 'openProcess' , process ) ; 

      const response = {
        ... typeof process.json == 'string' ? JSON.parse( process.json ) : process.json , 
        protocols : protocols , 
      } ; 

      // Json이 null이 올 경우를 대비
      const defaultJson = {
        nodes : [] , 
        links : [] , 
        protocols : [ ...protocols ] , 
      } ; 
      
      // console.log({ defaultJson }) ; 
  
      // 공정도 설정
      state.process = {
        ...process , 
        json : process.json ? response : defaultJson , 
      } ; 

      // console.log( 'state.process : ' , state.process ) ; 

      // Object.assign( state.processInfo , {
      //   ...state.processInfo , 
      //   ...state.process.json , 
      // }) ;  

      state.processInfo = { 
        ...state.processInfo , 
        ...state.process.json ,
      }

      if ( response.nodes == undefined || response.nodes.length == 0 ) { // 프로세스가 비어있는지 유무 
        state.emptyProcess = true ; 
      } else {
        state.emptyProcess = false ; 
      }
  
      // 최근 사용내역 있는지 확인 
      let { process : { json : { nodes }}} = state ; 
      nodes.map(( node : any , idx : any ) => {
        let { category : nodeCategory , text : nodeText } = node ; 
        taglist.map(( element : any , idx : any ) => {
          let { category : elementCategory , tags : elementTags , label , useTags } = element ; 
          if ( nodeCategory == elementCategory ) {
            /* console.log( 
              'nodeCategory : ' , nodeCategory , '\n' , 
              'elementCategory : ' , elementCategory , '\n' , 
              'elementTags : ' , elementTags , '\n' , 
              'nodeText : ' , nodeText , '\n' , 
            ) ;  */
            elementTags.map(( tag : any ) => {
              if ( tag.name.trim() == nodeText.trim() ) {
                if ( nodeCategory == 'MATERIAL' ) {
                  // console.log( '===> tag.name.trim() : ' , tag.name.trim() , '|| nodeText.trim() : ' , nodeText.trim() ) ; 
                }
                if ( !useTags.includes( tag ) ) { // 중복 제거 
                  // console.log( 'tag.name : ' , tag.name ) ; 
                  useTags[ useTags.length ] = tag ; 
                }
              }
            }) ; 
          }
        }) ; 
      }) ; 
  
      taglist.map(( element : any , idx : any ) => {
        if ( element.useTags.length != 0 ) {
          element.status.tagListView = 'exist-tags' ; 
        }
      }) ; 

      // console.log( 'taglist : ' , taglist ) ; 
  
      Object.assign( state , { ...state , 
        elements : taglist , 
        pending : { ...state.pending , // 대기 종료 
          init : false , 
          detail : false , 
        } , 
      }) ; 
    } // end of if ( process && protocols ) 

    /*
    if ( process && protocols ) {
      rootState.Comm.$process.open( process ) ; 스토리지에 업로드 해야함
    }
    */
  } , 

  async refreshElements ({ state , dispatch , commit } , newJson : any ) {
    let { elements , process } = state ; 

    // console.log( 'newJson : ' , newJson ) ; 
    // console.log( 'state.process : ' , state.process ) ; 
    
    // 공정도 설정
    state.process = {
      ...process , 
      json : {
        nodes : newJson.nodes , 
        links : newJson.links , 
        // protocols : [ ...protocols ] , 
      }
    } ; 

    // 최근 사용내역 있는지 확인 
    let { process : { json : { nodes }}} = state ; 
    nodes.map(( node : any , idx : any ) => {
      let { category : nodeCategory , text : nodeText } = node ; 
      elements.map(( element : any , idx : any ) => {
        let { category : elementCategory , tags : elementTags , label , useTags } = element ; 
        if ( nodeCategory == elementCategory ) {
          elementTags.map(( tag : any ) => {
            if ( tag.name.trim() == nodeText.trim() ) {
              /* if ( nodeCategory == 'MATERIAL' ) {
                console.log( '===> tag.name.trim() : ' , tag.name.trim() , '|| nodeText.trim() : ' , nodeText.trim() ) ; 
              } */
              if ( !useTags.includes( tag ) ) { // 중복 제거 
                /* if ( nodeCategory == 'MATERIAL' ) {
                  console.log( 'tag.name : ' , tag.name ) ; 
                } */
                useTags[ useTags.length ] = tag ; 
              }
            }
          }) ; 
        }
      }) ; 
    }) ; 

    elements.map(( element : any , idx : any ) => {
      let { useTags } = element ; 
      useTags.map(( tag : any , jdx : any ) => {
        Vue.set( useTags , jdx , tag ) ; 
      }) ; 
    }) ; 

    Vue.set( state.processInfo , 'processId' , state.processInfo.processId ) ; 
  } , // end of refreshElements 

  openProcess ({ state } , item : any ) {
    let { items , localStorageKey } = state ; 
    /* console.log(
      '[ openProcess in ]\n' , 
      'items : ' , items , '\n' , 
      'item : ' , item , '\n' , 
    ) ;  */

    const exists =
    items.findIndex(
      ({ processId }) => +item.processId === +processId
    ) > -1;

    state.crntItem = item ; 

    // 존재하면 변경
    if (exists) {
      /* console.log( 
        'already exists' , '\n' , 
        'localStorageKey : ' , localStorageKey , '\n' , 
        'item.processId : ' , item.processId , '\n' , 
        'item : ' , item , '\n' , 
      ) ;  */

      items = items.map(( origin : any ) => { 
        // console.log( ' - item : ' , item ) ; 
        // console.log( ' - origin : ' , origin ) ; 

        if ( +item.processId === +origin.processId ) {
          let newItem = Object.assign( origin , { ...item }) ; 
          return newItem ; 
        } else {
          return origin ; 
        } 
      }) ; 

      // console.log( 'items : ' , items ) ; 
      localStorage.setItem( localStorageKey , JSON.stringify( items )) ; 
    } else {
      // console.log( 'new file') ; 
      if ( !item.hasOwnProperty( 'temporaryDeleteArr' ) ) {
        item.temporaryDeleteArr = {} ; 
      } 

      items.unshift(item);
      localStorage.setItem( localStorageKey , JSON.stringify( items )) ; 
    }
  } , 

  async getElements () {
    return new Promise( resolve => {
      const taglist:Object[] = [] ; 

      tagsArr.map(( tag ) => {
        let { type , color , name } = tag ; 
        let tmpObj = {
          label : name , 
          variant : color , 
        } ; 

        switch ( type ) {
          case 'EQUIPMENT' : 
            Object.assign( tmpObj , { 
              // disalbedAddTag: true, // 노드 추가 불가
              disalbedRemoveTag: true, // 노드 삭제 불가
              hasProtocol: true, // 프로토콜 있음
              temporaryDelete : false , // 임시 삭제 
            }) ; 
            break ; 
        } // end of switch 

        Object.assign( tmpObj , { 
          category : type , 
          tags: [] , 
          useTags : [] , 
          idx : taglist.length , 
          elemNodes : {} , 
          status : {
            size : {
              open : false , 
              gapH : 0 , 
              scrH : 0 , 
            } , 
            tagList : 'recent' , // recent : 최근 , garbage : 삭제목록
            tagListView : 'no-tags' , 
            /**
             * no-tags : 최근사용 태그가 없다.
             * exist-tags : 최근사용 태그가 있다.  
             * no-srch : 검색 태그가 없다.  
             * exist-srch : 검색 태그가 있다. 
             */
          } , 
          // open: false , 
          // scrH: 0 , 
        }) ; 

        taglist[ taglist.length ] = tmpObj ; 
      }) ; // end of tagsArr.map 

      resolve( taglist ) ;
    }) ; // end of new Poromise 
  } , // end of getElements 

  async getDetail ({ state , dispatch } , taglist : any ) {
    return new Promise ( async resolve => {
      const { 
        // 상세 불러오기 api && 프로토콜 전체 조회 api
        $wApi : {
          process : {
            detail , 
            getProtocols , 
          } , 
        } , 
        processId : id , 
        query , 
      } = state ; 
    
      Object.assign( state , { ...state , 
        nodeSelected : null , 
        pending : { ...state.pending , 
          init : true , 
          detail : true , 
        }
      }) ; 

      const [ process , protocols ] = await Promise.all([
        detail( null , id ) , 
        // getProtocols( null , id ) , 
        dispatch( 'getProtocols' , {
          id , 
          isMemo : true , 
          isConent : true , 
          isComment  : true , 
        }) , 
      ]) ; 

      // console.log({ process  , protocols }) ; 
      resolve({ process  , protocols }) ; 
    }) ; 
  } , // end of getDetail

  async getTags ({ state , rootState } , taglist : any ) {
    const { $wApi , query } = state ; 
    Object.assign( state.pending , { ...state.pending , 
      tags : true , 
    }) ; 

    const body = {
      type : query?.type , 
      name : query?.name || undefined , 
    } ; 

    // console.log( 'body : ' , body ) ; 

    const data = await $wApi.tag.gets( body ) ; 
    const types = {
      MATERIAL    : 'material' , 
      PROCESS     : 'process' , 
      MEASUREMENT : 'measurement' , 
      ANALYSIS    : 'analysis' , 
      EQUIPMENT   : 'equipment' , 
    } ; 

    // console.log(' data : ' , data ) ; 

    for ( let idx = 0 ; idx < taglist.length ; idx += 1 ) {
      const element = taglist[ idx ] ; 
      const current = data[ types[ element.category ]] ; 
      element.tags = [ ...current ] ; 
    }

    Object.assign( state.pending , { ...state.pending , 
      tags : false , 
    }) ; 
    return taglist ; 
  } , // end of getTags 

  async setProcess_N_UserInfo ({ state }) {
    let { processId , user } = state; 

    if( !processId ) return;
    // console.log('nnnn1')
    // console.log(
    //   'processId : ' , processId , '\n' , 
    //   'user : ' , user , '\n' , 
    // )

    let { 
      processName , 
      processType , 
      fieldId , 
      fieldName , 
      user : processUser 
    } = await $wApi.process.detail( null , processId ) ; 

    // console.log({
    //   processName , 
    //   processType , 
    // })

    Object.assign( state , {
      processInfo : {
        processId , 
        processName , 
        processType , 
        fieldId : fieldId ? fieldId : 0,
        fieldName: fieldName ? fieldName : ''
      } , 
      user : { 
        ...user , 
        ...processUser , 
      } , 
      localStorageKey : `protocol:opened:${ user.id }` , // 로컬스토리지에 열린 프로토콜 저장하는 키
    }) ; 
  } , 
  LNBTagNameViewHandler ({ state } , { viewBln = false , name = '' , elem = null }) {
    Object.assign( state.LNBTagBalloon , {
      ...state.LNBTagBalloon , 
      viewBln , 
      elem , 
      name , 
    }) ; 
  } , 
  LNBTagContextMenuVIewHandler ({ state } , { viewBln = false , tag = null , elem = null , crntElement = null }) {
    Object.assign( state.LNBTagContextMenu , {
      ...state.LNBTagContextMenu , 
      viewBln , 
      elem , 
      tag , 
      crntElement , 
    }) ; 
  } , 
  async searchTag ({ state } , { name , type }) {
    const { $wApi } = state ; 
    const data = $wApi.tag.gets({ name , type }); 
    return data ; 
  } , 
  async addTag ({ state } , { name , tagType }) {
    const { $wApi } = state ; 
    try {
      const body = {
        name , 
        tagType , 
      } ; 

      const data = await $wApi.tag.post( body ) ; 
      // console.log( 'data : ' , data ) ; 
      return data ; 

    } catch ( error ) {
      console.log(' error : ' , error ) ; 
    }
  } , 
  deleteUseTags ({ state } , { category , id }) {
    let { elements } = state ; 
    let crntElement = elements.filter(( element : any ) => element.category == category )[0] ; 

    /* crntElement.useTags.map(( tag : any ) => {
      console.log( 'tag : ' , tag ) ; 
    }) */

    crntElement.useTags = crntElement.useTags.filter(( tag : any ) => tag.id != id ) ; 
    /* console.log( 
      'deleteUseTags in\n' , 
      'crntElement.useTags : ' , crntElement.useTags , '\n' , 
    ) ;  */
  } , 
  addUseTags ({ state } , { category , useTag }) {
    let 
    { elements } = state , 
    crntIdx = 0 , 
    crntElement : any = null 
    ; 

    elements.map(( element : any , idx : number ) => {
      if ( element.category == category ) {
        crntIdx = idx ; 
      }
    }) ; 
    crntElement = elements[ crntIdx ] ; 

    /* console.log( 
      'addUseTags in\n' , 
      'crntElement : ' , crntElement , '\n' , 
    ) ;  */

    const oldUseTags = [ ...crntElement.useTags , useTag ] ; 
    const newUseTags = oldUseTags.reduce(function(acc, current) {
      if (acc.findIndex(({ id }) => id === current.id) === -1) {
        acc.push(current);
      }
      return acc;
    }, []);

    crntElement.useTags = [ ...newUseTags ] ; 

    /* console.log(
      '[ commnew.ts -> addUseTags in]\n' , 
      'crntIdx : ' , crntIdx , '\n' , 
      `elements[ ${ crntIdx } ] : ` , elements[ crntIdx ] , '\n' , 
      'crntElement : ' , crntElement , 
    ) ;  */
  } , 
  temporaryRecoveryArrHandler ({ state } , { crntItem , tagType , id }) {
    let { items , localStorageKey } = state ; 
    let { temporaryDeleteArr } = crntItem ; 
    temporaryDeleteArr[ tagType ] = temporaryDeleteArr[ tagType ].filter(( tagId : any ) => tagId != id ) ; 
    items.map(( item : any ) => {
      if ( item.processId == crntItem.processId ) 
      item = crntItem ; 
    }) ; 

    localStorage.setItem( localStorageKey , JSON.stringify( items )) ; 
  } , 
  temporaryAllDeleteArr ({ state } , { crntItem , tagType , useTags }) {
    let { items , localStorageKey } = state ; 
    let { temporaryDeleteArr } = crntItem ; 
    
    if ( !temporaryDeleteArr.hasOwnProperty( tagType )) {
      temporaryDeleteArr[ tagType ] = [] ; 
    } 
    temporaryDeleteArr[ tagType ] = [ ...new Set(useTags.map(( tag : any ) => tag.id )) ] ; 
    items.map(( item : any ) => {
      if ( item.processId == crntItem.processId ) 
      item = crntItem ; 
    }) ; 
    localStorage.setItem( localStorageKey , JSON.stringify( items )) ; 
  } , 
  temporaryDeleteArrHandler ({ state } , { crntItem , tagType , id }) {
    /* console.log(
      'temporaryDeleteArrHandler in\n' , 
    ) */

    let { items , localStorageKey } = state ; 
    let { temporaryDeleteArr } = crntItem ; 
     
    if ( !temporaryDeleteArr.hasOwnProperty( tagType )) {
      temporaryDeleteArr[ tagType ] = [] ; 
    } 

    temporaryDeleteArr[ tagType ][ temporaryDeleteArr[ tagType ].length ] = id ; 
    temporaryDeleteArr[ tagType ] = [ ...new Set(temporaryDeleteArr[ tagType ])] ; 

    items.map(( item : any ) => {
      if ( item.processId == crntItem.processId ) 
      item = crntItem ; 
    }) ; 

    localStorage.setItem( localStorageKey , JSON.stringify( items )) ; 
  } , 

  setTemplateData ({ state } , templateData : any ) {
    Object.assign( state , { ...state , 
      templateData , 
    }) ; 
  } , 

  // 불러온 템플릿 LNB 아코디언 세팅 
  // async setTemplateLNBInfo ({ state , commit , dispatch } , templateData : any ) {
  async setTemplateLNBInfo ({ state , commit , dispatch }) {
    let { templateData } = state ; 
    // console.log( state ) ; 
    let { items , crntItem , crntItem : { json } , localStorageKey , $wApi } = state ; 
    json = JSON.parse( json ) || { nodes:[], links:[] }; 
    // console.log( 'templateData : ' , templateData ) ; 
    // console.log( 'json : ' , ...json ) ; 

    Object.assign( json , {
      ...json , 
      links : [ ...json.links , 
        ...templateData.links
      ] , 
      nodes : [ ...json.nodes , 
        ...templateData.nodes
      ] , 
    }) ; 

    // console.log( 'json : ' , json ) ; 
    crntItem.json = JSON.stringify( json ) ; 

    // console.log( 'crntItem : ' , crntItem ) ; 
    items = items.map(( origin : any ) => { 
      // console.log( ' - item : ' , item ) ; 
      // console.log( ' - origin : ' , origin ) ; 

      if ( +crntItem.processId === +origin.processId ) {
        let newItem = Object.assign( origin , { ...crntItem }) ; 
        return newItem ; 
      } else {
        return origin ; 
      } 
    }) ; 

    // await $wApi.process.put({ json }, state.processId) ; 
    dispatch( 'refreshElements' , json ) ; 
  } , // end of setTemplateLNBInfo

  // async setTemplateDiagramInfo ({ state , dispatch } , templateData : any ) {
  async setTemplateDiagramInfo({ state , dispatch }) {
    let { templateData , crntPos } = state ; 
    const newTemplateDataNodes : any = [] ; 
    state.crntDiagram.startTransaction("Add State");
    let newKeyArr : any = [] ; 

    console.log(templateData)
    templateData.nodes.map(( data : any ) => {
      // console.log(' data : ' , data ) ; 
      let oldPos = data.position.split( ' ' ).map( Number ) ; 
      console.log(' crntPos : ' , crntPos ) ; 
      console.log( 'oldPos : ' , oldPos ) ; 

      let processCanvas = document.querySelector( state.processEditorElemID ) ; 
      let left = processCanvas.getBoundingClientRect().left ;
      let top = processCanvas.getBoundingClientRect().top ;

      let position = state.crntDiagram.transformViewToDoc( 
        new GO.Point( 
          oldPos[0] + crntPos.x - left , 
          oldPos[1] + crntPos.y - top , 
        ) 
      ) ; 
      console.log( 'position : ' , position ) ; 

      let newKey = v4() ; 
      newKeyArr[ newKeyArr.length ] = [ data.key , newKey ] ; 
      const newData = Object.assign({} , { 
        ...data , 
        position : `${position.x} ${position.y}`, 
        // position : state.crntDiagram.transformViewToDoc( new GO.Point( Math.random() * 500 , Math.random() * 500 ) ) , 
        key : newKey , 
        tagKey : newKey
      }) ; 
      delete newData.__gohashid ; 
      // console.log(' newData : ' , newData ) ; 
      newTemplateDataNodes[ newTemplateDataNodes.length ] = newData ; 
    }) ; 

    const newTemplateDataLinks : any = [] ; 
    templateData.links.map(( data : any ) => {
      let newFrom = '' ; 
      let newTo = '' ; 

      newKeyArr.map(([ oldKey , newKey ]) => {
        // console.log( 'oldKey : ', oldKey ) ; 
        // console.log( 'newKey : ', newKey ) ; 
        if ( data.to == oldKey ) newTo = newKey ; 
        if ( data.from == oldKey ) newFrom = newKey ; 
      }) ; 
      
      const newData = Object.assign({} , { 
        ...data , 
        // position : state.crntDiagram.transformViewToDoc( new GO.Point( Math.random() * 500 , Math.random() * 500 ) ) , 
        from : newFrom , 
        to : newTo , 
      }) ; 
      delete newData.__gohashid ; 
      // console.log( 'links newData : ' , newData ) ; 
      newTemplateDataLinks[ newTemplateDataLinks.length ] = newData ; 
    }) ; 

    // console.log( 'newTemplateDataNodes : ' , newTemplateDataNodes ) ; 
    newTemplateDataNodes.map(( newNode : any ) => {
      state.crntDiagram.model.addNodeData( newNode ) ; 
    }) ; 

    newTemplateDataLinks.map(( newNode : any ) => {
      state.crntDiagram.model.addLinkData( newNode ) ; 
    }) ; 

    state.crntDiagram.commitTransaction("Add State");
    state.crntDiagram.layout.invalidateLayout();
  } , 

  // convertIssuesStringToJSON
  async convertIssuesStringToJSON ({ state , commit , dispatch } , data : any ) {
    // console.log( 
    //   'state.processInfo : ' , state.processInfo , 
    //   'state.protocolId : ' , state.protocolId , 
    //   'state.processInfo.protocols : ' , state.processInfo.protocols , 
    // ) ; 
    // console.log({ data }) ; 

    // const crntProtocol = state.processInfo.protocols.filter(( p : any ) => p.keyOfProtocol == state.protocolId )[0] ; 
    const crntProtocol = state.processInfo.protocols.filter(( p : any ) => {
      if ( p.id == state.protocolId ) {
        return p ; 
      }
    })[0] ; 

    return new Promise( resolve => {
      const chkProtocolKeyFunc = () => {
        // console.log({ data }) ; 
        data.issues.map(( info : any ) => {
          // console.log( 'crntProtocol : ' , crntProtocol ) ; 
          info.protocolId = crntProtocol.id ; 
          if ( typeof info.parent == 'number' || !info.parent ) {
            // console.log( info.text ) ; // 0 depth 제목만을 찾기 
            info.parent = crntProtocol.id ; 
          }
        }) ; 
        resolve( data ) ; 
      } ; 
      
      const loopFunc = () => {
        if ( typeof data == 'object' ) {
          chkProtocolKeyFunc() ; 
        } else {
          data = JSON.parse( data ) ; 
          if ( typeof data == 'string' ) {
            loopFunc() ; 
          } else {
            chkProtocolKeyFunc() ; 
          }
        }
      }
      loopFunc() ; 
    }) ; 
  } , 

  // converStringToJSON
  async converStringToJSON ({ state , commit , dispatch } , data : any ) {
    return new Promise( resolve => {
      const loopFunc = () => {
        if ( typeof data == 'object' ) {
          resolve( data ) ; 
        } else {
          data = JSON.parse( data ) ; 
          if ( typeof data == 'string' ) {
            loopFunc() ; 
          } else {
            resolve( data ) ; 
          }
        }
      }
      loopFunc() ; 
    }) ; 
  } , 
  
} ; // end of actions 

const getters = {
  DIAGRAM ( state: any ) {
    return state.DIAGRAM
  },
  protocolId ( state : any ) {
    // console.log( 'state.protocolId : ' , state.protocolId ) ; 
    return state.protocolId ; 
  } , 
  processId ( state : any ) {
    return parseInt( state.processId ) ; 
  } , 
  pending () {
    return state.pending ; // 대기 모음
  } , 
  elements () { // 공정도 데이터 
    return state.elements ; 
  } , 
  items () { // 공정도 로컬스토리지 데이터 
    return state.items ; 
  } , 
  status () {
    return state.status ; 
  } , 
  crntItem () { // 공정도 로컬스토리지 현재 데이터 
    let { processId : processIdStr , items } = state ; 
    let processId = processIdStr == null ? 0 : parseInt( processIdStr ) ; 
    let crntItem = items.filter(( item : any ) => item.processId == processId )[0] ; 
    return crntItem ; 
  } , 
  localStorageKey () { // 로컬 스토리지 키 
    return state.localStorageKey ; // `protocol:opened:${this.user.id}`
  } , 
  LNBOpenBln () { // 아코디언 열림 닫힘 유무 
    return state.status.LNBOpenBln ; 
  } , 
  dragTag () { // 드래그 태그 
    return state.dragTag ; 
  } , 
  tagDropAbleBln ( state : any ) { // 드래그 태그 드랍 유무 
    return state.tagDropAbleBln ; 
  } , 
  PROCESS_INFO ( state : any ) {
    // console.log( 'state.processInfo : ' , state.processInfo )
    return state.processInfo ; 
  } , 
  USER_INFO ( state : any ) {
    return state.user ; 
  } , 
  LNBTagBalloon ( state : any ) {
    return state.LNBTagBalloon ; 
  } , 
  LNBTagContextMenu ( state : any ) {
    return state.LNBTagContextMenu ; 
  } , 
  $wApi ( state : any ) {
    return state.$wApi ; 
  } , 
  emptyProcess ( state : any ) {
    return state.emptyProcess ; 
  } , 
  editorProcessMotherElem ( state : any ) {
    return document.querySelector( state.processEditorElemID ) ; 
  } , 
  processEditorElemID ( state : any ) {
    return state.processEditorElemID ; 
  } , 
  crntDiagram ( state : any ) {
    return state.crntDiagram ; 
  } , 
  templateData ( state : any ) {
    return state.templateData ; 
  } , 
  crntPos ( state : any ) {
    return state.crntPos ; 
  } , 
  protocolIssueList ( state : any ) {
    return state.protocolIssueList ; 
  } , 
  slctProtocolKey ( state : any ) {
    return state.slctProtocolKey ; 
  } , 
  crntProtocolInfo ( state : any ) {
    return state.crntProtocolInfo ; 
  } , 
  crntDate ( state : any ) {
    const date    = new Date() ; 
    const year    = date.getFullYear() ; 
    const month   = `00${(date.getMonth() + 1)}`.slice( -2 ) ; 
    const day     = `00${(date.getDate() + 1)}`.slice( -2 ) ; 
    const minutes = date.getMinutes() + 1 ; 
    const seconds = date.getSeconds() + 1 ; 
    return `${year}.${month}.${day} ${minutes}:${seconds}` ; 
  } , 
  saveDuration ( state : any ) {
    return 10000 ;
  } ,
  editDuration ( state : any ) {
    //ms단위
    return 20000 ;
  } ,
  pdfWiki ( state : any ) {
    return state.pdfWiki ; 
  } , 
  getProtocolCreateFlag ( state : any ) {
      return state.protocolCreateFlag ; 
    } ,

  getInnerProtocolId ( state : any ) {
    return state.innerProtocolId ;
  } ,
  getProcessReadOnly ( state : any ) {
    return state.processReadOnly ;
  } ,

} ; // end of getters 

export default {
  namespaced: true,
  state ,
  mutations , 
  actions , 
  getters ,
} ; 